import _ from "lodash";

const DSRCmessage = {
	messageTypes: (() => {
		const messageTypes = [
			{
				slug: "MAP",
				id: 18,
				name: "mapData",
				display: "MAP data",
				shortDisplay: "MAP",
				expectedFrequency: 1,
				testable: true,
				standard: "J2735"
			},

			{
				slug: "SPAT",
				id: 19,
				name: "signalPhaseAndTimingMessage",
				display: "Signal Phase And Timing message",
				shortDisplay: "SPaT",
				expectedFrequency: 10,
				testable: true,
				standard: "J2735"
			},

			{
				slug: "BSM",
				id: 20,
				name: "basicSafetyMessage",
				display: "Basic Safety Message",
				shortDisplay: "BSM",
				testable: false,
				standard: "J2735"
			},

			{
				slug: "CSR",
				id: 21,
				name: "commonSafetyRequest",
				display: "Common Safety Request",
				shortDisplay: "CSR",
				standard: "J2735"
			},

			{
				slug: "EVA",
				id: 22,
				name: "emergencyVehicleAlert",
				display: "Emergency Vehicle Alert",
				shortDisplay: "EVA",
				standard: "J2735"
			},

			{
				slug: "ICA",
				id: 23,
				name: "intersectionCollision",
				display: "Intersection Collision Alert",
				shortDisplay: "ICA",
				standard: "J2735"
			},

			{
				slug: "NMEA",
				id: 24,
				name: "nmeaCorrections",
				display: "NMEA corrections",
				shortDisplay: "NMEA",
				standard: "J2735"
			},

			{
				slug: "PDM",
				id: 25,
				name: "probeDataManagement",
				display: "Probe Data Management",
				shortDisplay: "PDM",
				standard: "J2735"
			},

			{
				slug: "PVD",
				id: 26,
				name: "probeVehicleData",
				display: "Probe Vehicle Data",
				shortDisplay: "PVD",
				standard: "J2735"
			},

			{
				slug: "RSA",
				id: 27,
				name: "roadSideAlert",
				display: "Road Side Alert",
				shortDisplay: "RSA",
				standard: "J2735"
			},

			{
				slug: "RTCM",
				id: 28,
				name: "rtcmCorrections",
				display: "RTCM corrections",
				shortDisplay: "RTCM",
				standard: "J2735"
			},

			{
				slug: "SRM",
				id: 29,
				name: "signalRequestMessage",
				display: "Signal Request Message",
				shortDisplay: "SRM",
				standard: "J2735"
			},

			{
				slug: "SSM",
				id: 30,
				name: "signalStatusMessage",
				display: "Signal Status Message",
				shortDisplay: "SSM",
				standard: "J2735"
			},

			{
				slug: "TIM",
				id: 31,
				name: "travelerInformation",
				display: "Traveler Information Message",
				shortDisplay: "TIM",
				expectedFrequency: 1,
				testable: true,
				standard: "J2735"
			},

			{
				slug: "PSM",
				id: 32,
				name: "personalSafetyMessage",
				display: "Personal Safety Message",
				shortDisplay: "PSM",
				standard: "J2735"
			},

			{
				slug: "WSA",
				id: "WSA",
				name: "waveServiceAdvertisement",
				display: "WAVE Service Advertisement",
				shortDisplay: "WSA",
				testable: false,
				standard: "1609.3"
			}
		];

		const ret = {};
		var type;
		while ((type = messageTypes.shift())) {
			ret[type.id] = type;
			ret[type.slug] = ret[type.id];
			ret[type.name] = ret[type.id];
			ret[type.shortDisplay] = ret[type.id];
		}

		return ret;
	})(),

	get: getDSRCMessageType,
	getExpectedFrequency: getDSRCMessageExpectedFrequency,
	getWeight: getDSRCMessageWeight
};
export default DSRCmessage;

export function getDSRCMessageType(inP) {
	if (_.isObject(inP)) inP = inP.slug || inP.id || inP.name;
	return DSRCmessage.messageTypes[inP];
}

export function getDSRCMessageExpectedFrequency(inP) {
	const typeData = getDSRCMessageType(inP);
	return typeData && typeData.expectedFrequency;
}

export function getDSRCMessageWeight(srcKey, msgType) {
	var ret;
	const expectedFrequency = getDSRCMessageExpectedFrequency(msgType);
	switch (srcKey) {
		case "frequencyChecker":
			if (expectedFrequency) {
				ret = Math.max(1, expectedFrequency / 2);
			}
			break;
		case "partialParser":
		default:
			ret = 1;
			break;
	}
	return ret;
}
